import { useMutation } from "@tanstack/react-query"

import { axiosClient } from "$/http"

import { SurveySubmitData } from "../../models"
import { Urls } from "../urls"

export function useRespondentSurveySubmit(accessCode: string) {
    return useMutation({
        mutationFn: (data: { response: SurveySubmitData[] }) => axiosClient.post(Urls.submitSurvey(accessCode), data)
    })
}
